
import { defineComponent, ref } from '@nuxtjs/composition-api'
import kebabCase from 'lodash/kebabCase'
import { setupTranslationPrefixer } from '@/assets/util'
import { setupGtmCdpAction } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    url: { type: String, required: false, default: undefined },
    streamUrl: { type: String, required: false, default: undefined },
    eventDate: { type: Date, required: false, default: undefined },
    eventEndDate: { type: Date, required: false, default: undefined },
    location: { type: String, required: false, default: undefined },
    price: { type: Number, required: false, default: undefined },
    theme: { type: String, required: false, default: undefined },
    date: { type: Date, required: false, default: undefined },
    isFavorite: { type: Boolean, required: true },
    additionalEvents: { type: Array, required: false, default: () => [] },

    // Sale information from `setupTixSale`
    tixSale: { type: Object, required: false, default: () => ({}) },
    // concert status from "IConcert"
    concertStatus: { type: Object, required: false, default: () => ({}) },
    concertState: { type: Object, required: false, default: () => ({}) },
  },
  setup({ tixSale, concertStatus }, { emit }) {
    const showMoreEventDates = ref(false)
    const { saleAvailableFromDate, saleIcon, saleIsAvailable, saleIsAvailableInFuture, saleTemplate } = tixSale
    const { concertStatusLabel, concertStatusIcon } = concertStatus
    const gtmCdpAction = setupGtmCdpAction()

    const toggleShowAll = () => {
      showMoreEventDates.value = !showMoreEventDates.value
      if (showMoreEventDates.value) {
        gtmCdpAction('CV07 - See all dates clicked')
      }
    }

    return {
      concertStatusIcon,
      concertStatusLabel,
      saleAvailableFromDate,
      saleIcon,
      saleIsAvailable,
      saleIsAvailableInFuture,
      saleTemplate,
      kebabCase,
      showMoreEventDates,
      toggleShowAll,
      orderClick: () => emit('orderClick'),
      ...setupTranslationPrefixer('event-detail'),
      formatPrice: (price) => {
        const numberPrice = parseFloat(price.toString().replace(',', '.'))
        const formattedPrice = numberPrice.toFixed(2)
        return formattedPrice.replace('.', ',')
      },
    }
  },
})
